import { z } from 'zod';

/** Ten sam limit, co walidacja komentarza odrzucenia po stronie backendu (liczony po przycięciu). */
export const MAX_REJECTION_COMMENT_LENGTH = 1000;

export const rejectPendingChangeSchema = z.object({
  comment: z
    .string()
    .trim()
    .max(
      MAX_REJECTION_COMMENT_LENGTH,
      `Komentarz może mieć najwyżej ${MAX_REJECTION_COMMENT_LENGTH} znaków`,
    ),
});

export type RejectPendingChangeFormData = z.infer<
  typeof rejectPendingChangeSchema
>;
